import {
  LeadTextCode,
  HeadingTags,
  Listings,
} from '@/components/codeHighlights/TypographyCode';
import { InterFontCode } from './codeHighlights/InterFontCode';

const Typography: React.FC = () => {
  return (
    <>
      <h1>Typografie</h1>
      <p className="lead">
        Für die Online-Kanäle kommt durchgängig die Google-Schrift{' '}
        <a href="https://fonts.google.com/specimen/Inter?query=inter">Inter</a>{' '}
        zur Anwendung. Die verfügbaren Schriftschnitte sind im untersten Teil
        als Font Face gelistet.
      </p>
      <h2>Hinweis</h2>
      <p>
        Punktuell, etwa für das{' '}
        <a href={`${process.env.NEXT_PUBLIC_BASE_URL}/components/testimonial`}>
          Testimonial-Element
        </a>{' '}
        kommt die Schriftart Spectral zum Einsatz.
      </p>
      <h2 className="mt-5">Headings</h2>
      <p>
        Für Titelelemente sollte das semantische HTML mit folgerichtiger
        Anordnung Beachtung finden. Der H1-Tag sollte nur einmal pro Seite
        eingesetzt und immer an erster Stelle im Artikel positioniert sein. Der
        H1-Tag wird immer mit einer gelben 4px hohen und 80px breiten Linie
        angezeigt.
      </p>
      <p>
        Die Überschriften H2 bis H6 sollten in der logischen Reihenfolge
        eingesetzt werden. Die Überschrift H1 sollte dabei nicht in einem
        anderen Element, wie z.B. einem <code>&lt;header&gt;</code> oder{' '}
        <code>&lt;main&gt;</code>, verwendet werden. Der H2-Tag hat eine graue
        4px hohe Linie die sich über die gesamte Breite des Inhalts ausdehnt.
      </p>
      <h1>Pure H1 tag without class</h1>
      <h2>Heading H2</h2>
      <h3>Heading H3</h3>
      <h4>Heading H4</h4>
      <h5>Heading H5</h5>
      <h6>Heading H6</h6>
      <h2 className="mt-5">Paragraph mit h-Elementen</h2>
      <p>
        Alternativ können Titelelemente auch mit einem Paragraph eingesetzt
        werden. Diese Kombination stellt eine Ausnahme dar und findet in den
        meisten Fällen keine Anwendung.
      </p>
      <p className="h1 mt-5">h1. Bootstrap heading with paragraph tag</p>
      <p className="h2">h2. Bootstrap heading with paragraph tag</p>
      <p className="h3">h3. Bootstrap heading with paragraph tag</p>
      <p className="h4">h4. Bootstrap heading with paragraph tag</p>
      <p className="h5">h5. Bootstrap heading with paragraph tag</p>
      <p className="h6">h6. Bootstrap heading with paragraph tag</p>
      <div className="mt-5">
        <HeadingTags />
      </div>
      <h2 className="mt-5">Paragraph</h2>
      <div className="alert alert-light" role="alert">
        <span className="badge bg-secondary">Hinweis</span> Für den{' '}
        <i>Leadtext</i> stehen zwei CSS-Klassen zur Verfügung:{' '}
        <code>.lead</code> für die neue Version 5. Alternativ darf auch die
        CSS-Klasse <code>.text__lead</code> wie im Styleguide V4 zur Anwendung
        kommen. Bevorzugt ist die CSS-Klasse <code>.lead</code> anzuwenden.
      </div>
      <h3 className="mt-5">Paragraph "lead-text"</h3>
      <p className="lead">
        Lorem ipsum <a href="#">dolor sit amet consectetur adipisicing elit</a>.
        Veritatis eos, commodi autem porro, ex quo odio illo quas nisi ratione
        sunt, delectus cum quam ad voluptatibus. Quia dolores natus veritatis
        veniam, officiis aperiam sed laboriosam consectetur repellendus commodi
        sit, exercitationem sint magni illo maxime fugiat blanditiis aut error
        quas odio mollitia minima ratione nostrum modi? Maxime ipsa nihil quasi
        excepturi assumenda eum! Iusto, beatae? Perspiciatis doloremque minus,
        explicabo nisi illo aspernatur. Eaque perferendis culpa dolores et
        mollitia, vero officiis. Praesentium eligendi nam quas distinctio ex
        doloribus minima odio! Eius doloremque nihil odit harum, non labore.
        Recusandae facere aliquam porro placeat?
      </p>
      <p className="text__lead">
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Inventore,
        dolores! Impedit eveniet deleniti maiores tenetur eum officia vel eos,
        dignissimos cumque? Natus tempore earum facere porro a vel dolores
        dicta.
      </p>
      <h3>Standard Paragraph für den Fliesstext</h3>
      <p>
        Lorem ipsum dolor,{' '}
        <a href="#">dolor sit amet consectetur adipisicing elit</a>. Nemo
        adipisci quae veniam ab cupiditate, autem ut qui consectetur optio quas
        voluptatum, neque minus sequi. Consectetur recusandae quaerat corporis
        vero porro libero est doloribus! Quos tempore, laudantium ullam aliquid
        distinctio id exercitationem quas odio similique libero harum numquam
        veritatis officiis, aspernatur voluptatem! Rem consectetur est incidunt
        dicta saepe eum, error iure nulla excepturi asperiores quos, dolore
        explicabo ad id hic illo perferendis provident laudantium. Adipisci
        molestias consequuntur ex atque nostrum placeat, ratione, dolor quidem
        eum tempora asperiores officiis ea eos cumque. Magni ab facere eligendi
        temporibus fugit porro odit dolor velit!
      </p>
      <div className="mt-5">
        <LeadTextCode />
      </div>
      <h2 className="mt-5">Listenelemente</h2>
      <p>
        Es stehen vier Typen für Listenelemente zur Verfügung. Häufige
        Verwendung finden die ungeordneten und nummerierte Listen. Die unstyled-
        und inline Listen finden wenig bis kaum Anwendung. Sie sind hier dennoch
        beispielhaft dargestellt.
      </p>
      <h3>Unordered list</h3>
      <ul className="mb-5">
        <li>Lorem ipsum dolor sit amet</li>
        <li>Consectetur adipiscing elit</li>
        <li>
          Integer molestie lorem at massa
          <ul>
            <li>Inline list 1</li>
            <li>Inline list 2</li>
            <li>
              Inline list 3
              <ul>
                <li>Inline list 1</li>
                <li>Inline list 2</li>
                <li>Inline list 3</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>Facilisis in pretium nisl aliquet</li>
      </ul>
      <h3>Numbered list</h3>
      <ol className="mb-5">
        <li>Lorem ipsum dolor sit amet</li>
        <li>Consectetur adipiscing elit</li>
        <li>Integer molestie lorem at massa</li>
        <li>Facilisis in pretium nisl aliquet</li>
      </ol>
      <h3 className="mt-5">List unstyled</h3>
      <ul className="list-unstyled mb-5">
        <li>Lorem ipsum dolor sit amet</li>
        <li>Consectetur adipiscing elit</li>
        <li>Integer molestie lorem at massa</li>
        <li>Facilisis in pretium nisl aliquet</li>
        <li>
          Nulla volutpat aliquam velit
          <ul className="list-unstyled">
            <li>Phasellus iaculis neque</li>
            <li>Purus sodales ultricies</li>
            <li>
              <ul>
                <li>Phasellus iaculis neque</li>
                <li>Purus sodales ultricies</li>
                <li>Vestibulum laoreet porttitor sem</li>
                <li>
                  <ul className="list-unstyled">
                    <li>Phasellus iaculis neque</li>
                    <li>Purus sodales ultricies</li>
                    <li>
                      <ul className="list-unstyled">
                        <li>Phasellus iaculis neque</li>
                        <li>Purus sodales ultricies</li>
                        <li>Vestibulum laoreet porttitor sem</li>
                        <li>Ac tristique libero volutpat at</li>
                      </ul>
                    </li>
                    <li>Ac tristique libero volutpat at</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>Ac tristique libero volutpat at</li>
          </ul>
        </li>
        <li>Faucibus porta lacus fringilla vel</li>
        <li>Aenean sit amet erat nunc</li>
        <li>Eget porttitor lorem</li>
      </ul>
      <h3>List inline</h3>
      <ul className="list-inline">
        <li>Lorem ipsum dolor sit amet.</li>
        <li>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
          dolor.
        </li>
      </ul>
      <div className="mt-5">
        <Listings />
      </div>
      <div className="mt-5">
        <h2>Inter Font</h2>
        <p>
          Dieser Auszug dient zur Übersicht welche Schriftschnitte zur Anwendung
          kommen. Diese Schriftschnitte sind bereits im fhnw.css (siehe
          Download-Paket) implementiert.
        </p>
        <InterFontCode />
      </div>
    </>
  );
};

export default Typography;
